import { ReactElement, useContext } from "react";
import { Button } from "@justworkshr/milo-core";
import RemoveFactorButton from "../removeFactorButton/RemoveFactorButton";

import { Factor } from "types/factor/factor";

import DisableFactorSetupContext from "../../../contexts/DisableFactorSetupContext";

const HeaderButton = ({
  factor,
  showSetUpButton,
  showRemoveButton,
  onClickSetup,
}: {
  factor: Factor;
  showSetUpButton: boolean;
  showRemoveButton: boolean;
  onClickSetup: () => void;
}): ReactElement => {
  const { disableFactorSetup } = useContext(DisableFactorSetupContext);
  return (
    <>
      {showSetUpButton && (
        <Button
          variant="outlined"
          onClick={onClickSetup}
          disabled={disableFactorSetup}
        >
          Set Up
        </Button>
      )}

      {showRemoveButton && <RemoveFactorButton factor={factor} />}
    </>
  );
};

export default HeaderButton;
